<script setup lang="ts">
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import SBOBaseLayout from '../layouts/SBOBaseLayout.vue'
import SBOAuthLayout from '../layouts/SBOAuthLayout.vue'

const LAYOUT_COMPONENT_MAP = {
  BaseLayout: SBOBaseLayout,
  AuthLayout: SBOAuthLayout
}

const route = useRoute()

const showLayoutComponent = computed(() => !!route.name)
const layoutComponent = computed(() => {
  const layoutName = route.meta?.layout as keyof typeof LAYOUT_COMPONENT_MAP

  return LAYOUT_COMPONENT_MAP[layoutName] || LAYOUT_COMPONENT_MAP.BaseLayout
})
</script>

<template>
  <component :is="layoutComponent" v-if="showLayoutComponent" />
</template>
